export default "__VITE_ASSET__513RExJ4__"